import React, { useEffect, useState, useMemo } from "react";
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom"
import { formatNumberWithCommas } from '../../common/utility'

import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Nav,
    NavItem,
    Row,
    TabContent,
    TabPane,
    NavLink
} from "reactstrap";

//Import Breadcrumb
import TableContainerV1 from "components/Common/TableContainerV1";
import { callgetFileByFileId, callGetAllFileData, callGetAllFileDataCount } from "http/auth/signup";
import classnames from "classnames"

const BulkProductStatus = () => {
    const navigate = useNavigate();
    document.title = "Users | DMS";
    const [userList, setUserList] = useState([]);
    const [fileCount, setFileCount] = useState(null);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageCount: 0,
        totalRecords: 0,
    });
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [columnId, setColumnId] = useState("id");
    const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
    const urlParams = new URLSearchParams(window.location.search)
    const encodedId = urlParams.get("id")
    const decodedId = atob(encodedId)
    const [sortingOptions, setSortingOptions] = useState({
        column: "id",
        isAsc: false,
        optionalColumn: ["Action", "productName", "category", "sellingPrice", "costPrice", "subCategory", "sku"],
    });
    const [customActiveTab, setCustomActiveTab] = useState("1")
    const [status, setStatus] = useState(1);

    const toggleCustom = tab => {
        if (customActiveTab != tab) {
            setCustomActiveTab(tab)
            setStatus(tab)
        }
    }

    const columns = useMemo(
        () => [
            {
                Header: 'Batch Id',
                accessor: 'batchId',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value || 'NA';
                }
            },
            {
                Header: 'product Name',
                accessor: 'productName',
                filterable: true,
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    return rowData.fileData?.productName || 'NA';
                }
            },
            {
                Header: 'Category',
                accessor: 'category',
                filterable: true,
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    return rowData.fileData?.category || 'NA';
                }
            },
            {
                Header: 'Sub Category',
                accessor: 'subCategory',
                filterable: true,
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    return rowData.fileData?.subCategory || 'NA';
                }
            },
            {
                Header: 'SKU',
                accessor: 'sku',
                filterable: true,
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    return rowData.fileData?.sku || 'NA';
                }
            },
            {
                Header: 'Selling Price',
                accessor: 'sellingPrice',
                filterable: true,
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    return formatNumberWithCommas(rowData.fileData?.sellingPrice) || 'NA';
                }
            },
            {
                Header: 'Cost Price',
                accessor: 'costPrice',
                filterable: true,
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    return formatNumberWithCommas(rowData.fileData?.costPrice) || 'NA';
                }
            },
            {
                Header: 'Field Error',
                accessor: 'errorValue',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value || 'NA'
                }
            },
        ],
        []
    );

    const columns2 = useMemo(
        () => [
            {
                Header: 'Id',
                accessor: 'id',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value || '';
                }
            },
            {
                Header: 'Batch Id',
                accessor: 'batchId',
                filterable: true,
                Cell: (cellProps) => {
                    return cellProps.value || 'NA';
                }
            },
            {
                Header: 'product Name',
                accessor: 'productName',
                filterable: true,
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    return rowData.fileData?.productName || 'NA';
                }
            },
            {
                Header: 'Category',
                accessor: 'category',
                filterable: true,
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    return rowData.fileData?.category || 'NA';
                }
            },
            {
                Header: 'Sub Category',
                accessor: 'subCategory',
                filterable: true,
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    return rowData.fileData?.subCategory || 'NA';
                }
            },
            {
                Header: 'SKU',
                accessor: 'sku',
                filterable: true,
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    return rowData.fileData?.sku || 'NA';
                }
            },
            {
                Header: 'Selling Price',
                accessor: 'sellingPrice',
                filterable: true,
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    return formatNumberWithCommas(rowData.fileData?.sellingPrice) || 'NA';
                }
            },
            {
                Header: 'Cost Price',
                accessor: 'costPrice',
                filterable: true,
                Cell: (cellProps) => {
                    const rowData = cellProps.row.original;
                    return formatNumberWithCommas(rowData.fileData?.costPrice) || 'NA';
                }
            },
        ],
        []
    );

    const getUserList = async (body) => {
        const response = await callgetFileByFileId(body);
        if (response.status) {
            setUserList(response.data.data);
            const { totalItems, totalPages, currentPage } = response.data
            setPagination({
                pageIndex: currentPage,
                pageCount: totalPages,
                totalRecords: totalItems,
            })
        } else {
            setUserList([]);
            setPagination({
                pageIndex: 0,
                pageCount: 0,
                totalRecords: 0,
            })
        }
    }

    useEffect(() => {
        const bodyData = {
            status,
            page: currentPage,
            limit: pageSize,
            columnName: columnId,
            sortingOrder: sortingOrderStatus,
            batch: decodedId
        }
        getUserList(bodyData);
        getDataCount()
    }, [pageSize, columnId, sortingOrderStatus, currentPage, status]);

    const getDataCount = async () => {
        const response = await callGetAllFileDataCount({
            dataType: 'product',
            batchId: decodedId
        })
        if (response.status) {
            setFileCount(response.data)
        }
    }

    const handlePageChange = (page, pageSize) => {
        setPageSize(pageSize);
        setCurrentPage(page);
    }

    const handleSortColumn = (option) => {
        setSortingOptions(option);
        const columnName = option.column;
        setColumnId(columnName);
        const sortingOrder = option.isAsc ? "asc" : "desc";
        setSortingOrderStatus(sortingOrder);
    };

    const buttonSection = (
        <div className="text-sm-end">
            {userList.length > 0 && customActiveTab == 3 && (<Button
                type="button"
                color="success"
                className="btn-rounded mb-2 me-2"
                onClick={() => { createAndDownloadExcel('Products', status, decodedId) }}
            >
                <i className="mdi mdi-download me-1" />
                {'Download'}
            </Button>)}
        </div>
    )
    return (
        <div className="page-content">
            <Container fluid >
                <div className='page-title-box d-flex gap-3 justify-content-between align-items-center'>
                    <h4 className="mb-sm-0 font-size-18">PRODUCT STATUS</h4>
                    <div className="d-flex gap-3 justify-content-end">
                        <button
                            className="btn btn-outline-success"
                            type="button"
                            onClick={() => { navigate(-1) }}
                        >
                            {'Back'}
                        </button>
                    </div>
                </div>
                <Row className="vertical-scroll">
                    <Col xs="12">
                        <Card>
                            <CardBody>
                                <Nav tabs className="nav-tabs-custom nav-justified">
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: customActiveTab === "1",
                                            })}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                toggleCustom("1")
                                            }}
                                        >
                                            <span className="d-block d-sm-none">
                                                <i className="fas fa-home"></i>
                                            </span>
                                            <span className="d-none d-sm-block">
                                                All Records({fileCount?.completedBatchDataCount})
                                            </span>
                                        </NavLink>
                                    </NavItem>

                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: customActiveTab === "2",
                                            })}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                toggleCustom("2")
                                            }}
                                        >
                                            <span className="d-block d-sm-none">
                                                <i className="far fa-user"></i>
                                            </span>
                                            <span className="d-none d-sm-block">
                                                Successfully Completed Records({fileCount?.pendingBatchDataCount})
                                            </span>
                                        </NavLink>
                                    </NavItem>

                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: customActiveTab === "3",
                                            })}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                toggleCustom("3")
                                            }}
                                        >
                                            <span className="d-block d-sm-none">
                                                <i className="far fa-user"></i>
                                            </span>
                                            <span className="d-none d-sm-block">
                                                Failed Records({fileCount?.errorBatchDataCount})
                                            </span>
                                        </NavLink>
                                    </NavItem>

                                </Nav>
                                <TabContent
                                    activeTab={customActiveTab}
                                    className="p-3 text-muted"
                                >
                                    <TabPane tabId="1">
                                        <Row>
                                            <Col>
                                                <TableContainerV1
                                                    columns={columns}
                                                    data={userList}
                                                    pagination={pagination}
                                                    handlePageChange={handlePageChange}
                                                    // handleSearchFilter={handleSearchFilter}
                                                    sortOptions={sortingOptions}
                                                    customSection={buttonSection}
                                                    handleSortColumn={handleSortColumn}
                                                    // handleClearSearch={handleClearSearch}
                                                    className="custom-header-css"
                                                />
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <Row>
                                            <Col>
                                                <TableContainerV1
                                                    columns={columns2}
                                                    data={userList}
                                                    pagination={pagination}
                                                    handlePageChange={handlePageChange}
                                                    // handleSearchFilter={handleSearchFilter}
                                                    sortOptions={sortingOptions}
                                                    customSection={buttonSection}
                                                    handleSortColumn={handleSortColumn}
                                                    // handleClearSearch={handleClearSearch}
                                                    className="custom-header-css"
                                                />
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="3">
                                        <Row>
                                            <Col>
                                                <TableContainerV1
                                                    columns={columns}
                                                    data={userList}
                                                    pagination={pagination}
                                                    handlePageChange={handlePageChange}
                                                    // handleSearchFilter={handleSearchFilter}
                                                    sortOptions={sortingOptions}
                                                    customSection={buttonSection}
                                                    handleSortColumn={handleSortColumn}
                                                    // handleClearSearch={handleClearSearch}
                                                    className="custom-header-css"
                                                />
                                            </Col>
                                        </Row>
                                    </TabPane>
                                </TabContent>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default BulkProductStatus;

const createAndDownloadExcel = async (fileName, status, id) => {
    const response = await callGetAllFileData({ fileId: id, status: status });
    if (response.status) {
        let newData = response.data.rows.map((ele) => {

            return {
                sku: ele.fileData.sku || '',
                model: ele.fileData.model || '',
                image1: ele.fileData.image1 || '',
                image2: ele.fileData.image2 || '',
                image3: ele.fileData.image3 || '',
                image4: ele.fileData.image4 || '',
                image5: ele.fileData.image5 || '',
                baseUnit: ele.fileData.baseUnit || '',
                category: ele.fileData.category || '',
                costPrice: ele.fileData.costPrice || '',
                productName: ele.fileData.productName || '',
                subCategory: ele.fileData.subCategory || '',
                sellingPrice: ele.fileData.sellingPrice || '',
                productDescription: ele.fileData.productDescription || ''
            }
        })
        const ws = XLSX.utils.json_to_sheet(newData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1');
        const buffer = XLSX.write(wb, { bookType: 'xlsx', bookSST: false, type: 'array' });
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.download = `${fileName}.xlsx`;
        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};
